import { IconFa, PlainButton } from '@glow/ui-components'
import i18next from 'i18next'
import { useEffect, useState } from 'react'

const COPIED_RESET_MS = 2_000

export const AiCopyButton = ({ text }: { text: string }) => {
  const [copied, setCopied] = useState(false)

  useEffect(() => {
    if (!copied) {
      return
    }
    const timer = setTimeout(() => setCopied(false), COPIED_RESET_MS)
    return () => clearTimeout(timer)
  }, [copied])

  const copy = () =>
    globalThis.navigator.clipboard
      .writeText(text)
      .then(() => setCopied(true))
      .catch(() => undefined)

  return (
    <PlainButton
      onClick={copy}
      aria-label={i18next.t(copied ? 'aiChat.copied' : 'aiChat.copyAnswer')}
      className="rounded px-1.5 py-1 text-emphasis-medium hover:text-emphasis-high"
    >
      <IconFa icon={['far', copied ? 'check' : 'copy']} size="sm" className={copied ? 'text-primary-500' : undefined} />
    </PlainButton>
  )
}
